import { memo } from 'react';
import { useRouter } from 'next/router';
import classNames from 'classnames';
import Link from 'components/Link';
import cleanObject from 'utils/clean-object';

function ButtonFilters({ facet, filterParam = '', path, promotion, terms }) {
  const router = useRouter();
  return (
    <>
      {terms.map(({ term, displayTerm }) => {
        if (!term) return null;
        const paramValue = encodeURIComponent(`${facet}^term^${term}`);

        const isAlreadySelected = filterParam.split(',').includes(paramValue);
        const filterQueryParam = filterParam
          ? isAlreadySelected
            ? filterParam.replace(paramValue, '')
            : `${filterParam},${paramValue}`
          : paramValue;
        return (
          <li
            key={term}
            data-value="filter"
            className={classNames(
              'border border-primary d-inline-block me-5 mb-5 p-4',
              { 'bg-primary': isAlreadySelected }
            )}
          >
            <Link
              shallow
              href={{
                pathname: path,
                query: cleanObject({
                  sort: router.query.sort,
                  filters: filterQueryParam,
                  promotion,
                  search: router.query.search,
                }),
              }}
              className={classNames({ 'text-white': isAlreadySelected })}
            >
              {displayTerm ?? term}
            </Link>
          </li>
        );
      })}
    </>
  );
}

export default memo(ButtonFilters);
